import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            热门商品分类
          </h2>
          <p className="text-foreground-600 text-sm mt-2">一站式选购全球母婴好物</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}